/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-08-04 16:22:46
 * @LastEditors: 
 * @LastEditTime: 2020-08-04 17:25:53
 */
import Table from './table';

export default Table